import React, { Fragment } from 'react';
import { Field } from 'react-final-form';
import { FormControl, InputGroup } from 'react-bootstrap';

const InputField = ({ input, ...rest }) => <FormControl {...input} {...rest} />;

const NumberField = ({ input, ...rest }) => (
  <InputGroup>
    <InputGroup.Addon>$</InputGroup.Addon>
    <FormControl bsSize="small" type={'text'} {...input} {...rest} />
  </InputGroup>
);

export default (creditor, index) => (
  <Fragment>
    <tr>
      <td rowSpan={2}>
        <label>
          <span className="label">Name</span>
        </label>
        <Field name={`${creditor}.creditor_name`} component={InputField} placeholder="Name" />

        <label>
          <span className="label">Street</span>
        </label>
        <Field name={`${creditor}.creditor_address_street`} component={InputField} placeholder="Street" />

        <label>
          <span className="label">City</span>
        </label>
        <Field name={`${creditor}.creditor_address_city`} component={InputField} placeholder="City" />

        <label>
          <span className="label">State</span>
        </label>
        <Field name={`${creditor}.creditor_address_state`} component={InputField} placeholder="State" />

        <label>
          <span className="label">Zip Code</span>
        </label>
        <Field name={`${creditor}.creditor_address_zip_code`} component={InputField} placeholder="Zip Code" />

        <label>
          <span className="label">Country</span>
        </label>
        <Field name={`${creditor}.creditor_address_country`} component={InputField} placeholder="Country" />
      </td>
      <td>
        <Field
          name={`${creditor}.contact_address`}
          component={InputField}
          componentClass="textarea"
          rows="4"
          className="address"
          cols="15"
          placeholder="Creditor Telephone and Email Contact"
        />
      </td>
      <td>
        <Field
          name={`${creditor}.claim_type`}
          component={InputField}
          type="text"
          className="claimType"
          size="15"
          placeholder="Nature of the claim"
        />
      </td>
      <td>
        <Field name={`${creditor}.claim_status`} component={InputField} componentClass="textarea" />
      </td>
    </tr>
    <tr style={{ borderBottom: '1px solid gray' }}>
      <td colSpan={3}>
        <table id="creditors">
          <thead>
            <tr>
              <th colSpan="3" style={{ width: 270 }}>
                <span className="label">Amount of unsecured claim</span>
              </th>
            </tr>
            <tr>
              <th>Total claim, if partially secured</th>
              <th>Deduction for value of collateral or setoff</th>
              <th>Unsecured claim</th>
            </tr>
          </thead>
          <tbody>
            <td className="money">
              <Field name={`${creditor}.total`} component={NumberField} size="8" />
            </td>
            <td className="money">
              <Field name={`${creditor}.deduction`} component={NumberField} size="8" />
            </td>
            <td className="money">
              <Field name={`${creditor}.unsecured`} component={NumberField} size="8" />
            </td>
          </tbody>
        </table>
      </td>
    </tr>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_top20/TopTwentyCreditorForm.jsx